<template>
    <div>
        <v-checkbox
                v-model="adjusted_offer"
                color="primary"
                required
        >
            <div slot="label">
                Pošiljanje prilagojene ponudbe (npr. rojstnodnevne sms ugodnosti, kuponi ugodnosti za izbran segment kupcev, obveščanje o stanju ugodnosti na vaši Tuš klub kartici, vam prilagojene ponudbe izdelkov in popustov, ipd.)
            </div>
        </v-checkbox>
        <v-checkbox
                v-model="market_researches"
                color="primary"
                required
        >
            <div slot="label">
                Trženjske raziskave (npr. raziskave o nakupovalni izkušnji)
            </div>
        </v-checkbox>
    </div>
</template>

<script>
    import utils from "../store/utils";

    export default {
        name: "Consents",
        props: {
            vuex_module: {
                type: String,
                default: 'registration'
            },
        },
        computed: {
            adjusted_offer: utils.vuexBuildSetGet(this, null, 'consents.adjusted_offer', null, 'registration/refreshConsent'),
            market_researches: utils.vuexBuildSetGet(this, null, 'consents.market_researches', null, 'registration/refreshConsent')
        }
    }
</script>

<style scoped>

</style>